import React from "react";
import { Layout } from "Components/Layout/Layout";
import { lazyLoader } from "Service/loader";
const ServiceTaskAdd = lazyLoader(
  () => import("Containers/ServiceTasks/ServiceTaskAddEdit/ServiceTaskAdd")
);

export const ServiceTaskAddPage = () => {
  return (
    <Layout>
      <ServiceTaskAdd />
    </Layout>
  );
};
